module.exports = __webpack_public_path__ + "static/media/day27.workshop.ce08cd7c.md";